import { useEffect } from 'react'
import { useLocalization } from '@racefront/common/context/localization-context'
import { SuppotedLocales } from '@racefront/common/i18n'
import { useAuthStore } from '../stores/auth.store'

export function useUserLocaleSync() {
  const { session, user } = useAuthStore()
  const { setLocale, locale } = useLocalization()

  useEffect(() => {
    const userLocale = (user?.locale || session?.idTokenDecoded?.locale) as SuppotedLocales | undefined

    if (userLocale && userLocale !== locale) {
      setLocale(userLocale)
    }
  }, [user?.locale, session?.idTokenDecoded?.locale, setLocale, locale])
}
